<template>
    <div class="seat-container">
        <div class="seat-id is-inline-block is-size-7">
            &nbsp;
        </div>
    </div>
</template>

<script>

export default {
  components: {
  },
  methods: {
  },
  props: {
  },
  computed: {

  }
}

</script>

<style scoped>
.seat-container {
    position: relative;
    margin: 5px
}


@media screen and (max-width: 1023px) {
  .seat-id {
      padding: 2px;
      border-radius: 10px;
      min-width: 30px;
      min-height: 30px;
      line-height: 20px;
      text-align: center;
      background: #fff;
  }
}

@media screen and (min-width: 1024px) {
  .seat-id {
      padding: 5px;
      border-radius: 10px;
      min-width: 40px;
      min-height: 30px;
      line-height: 20px;
      text-align: center;
      background: #fff;
  }
}


</style>
